import {connect} from '../../app/connect';
import IssueCreateFormAttachmentsSection from './IssueCreateFormAttachmentsSection';
import {getUploadingAttachments} from '../../app/selectors';
import {fetchProjectFolders, fetchFolderContents} from '../../app/actions';

const mapStateToProps = state => ({
  uploadingAttachments: getUploadingAttachments(state)
});

const mapDispatchToProps = {
  fetchProjectFolders,
  fetchFolderContents
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IssueCreateFormAttachmentsSection);
